module.exports = __webpack_public_path__ + "img/paintingAfter6.1644f75e.jpg";